var defaultBlocks = [{
  '@type': '@builder.io/sdk:Element',
  '@version': 2,
  layerName: 'SlideContainer',
  children: [{
    '@type': '@builder.io/sdk:Element',
    '@version': 2,
    layerName: 'MobileImage',
    component: {
      name: 'Image',
      options: {
        image: 'https://cdn.builder.io/api/v1/image/assets%2F1c781f29dc4a4769ad17cfb27a2f0806%2Feecc81e0cfd84047820d83349d6adacc',
        width: 732,
        backgroundSize: 'cover',
        aspectRatio: 1.399,
        fitContent: false,
        lockAspectRatio: false,
        height: 1024,
        backgroundPosition: 'center'
      }
    },
    children: [{
      '@type': '@builder.io/sdk:Element',
      '@version': 2,
      layerName: 'CTAContainer',
      children: [{
        '@type': '@builder.io/sdk:Element',
        '@version': 2,
        component: {
          name: 'Text',
          options: {
            text: '<h3>Savage X Retail</h3>'
          }
        },
        responsiveStyles: {
          medium: {
            display: 'flex',
            flexDirection: 'column',
            position: 'relative',
            flexShrink: '0',
            boxSizing: 'border-box',
            color: 'rgba(255, 255, 255, 1)',
            marginBottom: '4px',
            marginTop: 'auto',
            marginRight: 'auto',
            fontSize: '20px'
          }
        }
      }, {
        '@type': '@builder.io/sdk:Element',
        '@version': 2,
        layerName: 'A short description...',
        component: {
          name: 'Text',
          options: {
            text: '<p>New Xtra VIP Offer.</p>'
          }
        },
        responsiveStyles: {
          large: {
            display: 'flex',
            flexDirection: 'column',
            position: 'relative',
            flexShrink: '0',
            boxSizing: 'border-box',
            lineHeight: 'normal',
            height: 'auto',
            color: 'rgba(255, 255, 255, 1)',
            fontSize: '14px',
            marginBottom: '14px'
          },
          small: {
            paddingRight: '16px'
          }
        }
      }, {
        '@type': '@builder.io/sdk:Element',
        '@version': 2,
        meta: {
          localizedTextInputs: ['text', 'link']
        },
        component: {
          name: '_Cta_',
          options: {
            variant: 'white',
            text: {
              '@type': '@builder.io/core:LocalizedValue',
              Default: 'SHOP NOW'
            },
            link: {
              '@type': '@builder.io/core:LocalizedValue',
              Default: ''
            }
          }
        },
        responsiveStyles: {
          large: {
            display: 'flex',
            flexDirection: 'column',
            position: 'relative',
            flexShrink: '0',
            boxSizing: 'border-box',
            width: 'fit-content',
            textTransform: 'uppercase'
          }
        }
      }],
      responsiveStyles: {
        large: {
          position: 'relative',
          flexShrink: '0',
          boxSizing: 'border-box',
          alignSelf: 'stretch',
          zIndex: '1',
          flexGrow: '0',
          bottom: '0px',
          width: 'auto',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'flex-start',
          height: 'auto',
          paddingRight: '16px',
          paddingLeft: '16px',
          paddingBottom: '48px',
          paddingTop: '48px',
          marginTop: 'auto',
          marginRight: 'auto'
        },
        medium: {
          display: 'flex',
          flexDirection: 'column',
          marginRight: 'auto'
        }
      }
    }],
    responsiveStyles: {
      large: {
        display: 'none',
        flexDirection: 'column',
        height: '100%',
        flexGrow: '0'
      },
      medium: {
        width: '100%',
        height: 'auto',
        display: 'flex',
        flexGrow: '0'
      },
      small: {
        display: 'flex'
      }
    }
  }, {
    '@type': '@builder.io/sdk:Element',
    '@version': 2,
    layerName: 'DesktopImage',
    component: {
      name: 'Image',
      options: {
        image: 'https://cdn.builder.io/api/v1/image/assets%2F1c781f29dc4a4769ad17cfb27a2f0806%2F7d7f85e8dbcc428f8f3e53c699a0f2e1',
        width: 2272,
        backgroundSize: 'cover',
        aspectRatio: 0.391,
        fitContent: false,
        lockAspectRatio: false,
        height: 888,
        backgroundPosition: 'bottom'
      }
    },
    children: [{
      '@type': '@builder.io/sdk:Element',
      '@version': 2,
      layerName: 'CTAContainer',
      children: [{
        '@type': '@builder.io/sdk:Element',
        '@version': 2,
        id: 'builder-c61f08de01de431a8ce1d16ed1402f90',
        meta: {
          previousId: 'builder-f15f4720a9d4457e848b46e5d183773f'
        },
        component: {
          name: 'Text',
          options: {
            text: '<p>Savage X Retail</p>'
          }
        },
        responsiveStyles: {
          large: {
            display: 'flex',
            flexDirection: 'column',
            position: 'relative',
            flexShrink: '0',
            boxSizing: 'border-box',
            lineHeight: 'normal',
            height: 'auto',
            color: 'rgba(255, 255, 255, 1)',
            fontSize: '24px',
            marginBottom: '4px',
            fontWeight: '700',
            marginTop: 'auto',
            marginRight: 'auto'
          }
        }
      }, {
        '@type': '@builder.io/sdk:Element',
        '@version': 2,
        layerName: 'A short description...',
        component: {
          name: 'Text',
          options: {
            text: '<p>New Xtra VIP Offer.</p>'
          }
        },
        responsiveStyles: {
          large: {
            display: 'flex',
            flexDirection: 'column',
            position: 'relative',
            flexShrink: '0',
            boxSizing: 'border-box',
            lineHeight: 'normal',
            height: 'auto',
            color: 'rgba(255, 255, 255, 1)',
            fontSize: '14px',
            marginBottom: '14px'
          },
          small: {
            paddingRight: '16px'
          }
        }
      }, {
        '@type': '@builder.io/sdk:Element',
        '@version': 2,
        meta: {
          localizedTextInputs: ['text', 'link']
        },
        component: {
          name: '_Cta_',
          options: {
            variant: 'white',
            text: {
              '@type': '@builder.io/core:LocalizedValue',
              Default: 'SHOP NOW'
            },
            link: {
              '@type': '@builder.io/core:LocalizedValue',
              Default: ''
            }
          }
        },
        responsiveStyles: {
          large: {
            display: 'flex',
            flexDirection: 'column',
            position: 'relative',
            flexShrink: '0',
            boxSizing: 'border-box',
            width: 'fit-content',
            textTransform: 'uppercase'
          }
        }
      }],
      responsiveStyles: {
        large: {
          position: 'relative',
          flexShrink: '0',
          boxSizing: 'border-box',
          alignSelf: 'stretch',
          zIndex: '1',
          flexGrow: '0',
          bottom: '0px',
          width: 'auto',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'flex-start',
          height: 'auto',
          paddingRight: '16px',
          paddingLeft: '16px',
          paddingBottom: '48px',
          paddingTop: '48px',
          marginTop: 'auto',
          marginRight: 'auto'
        }
      }
    }],
    responsiveStyles: {
      large: {
        display: 'flex',
        flexDirection: 'column',
        flexGrow: '0',
        height: '100%',
        width: '100%'
      },
      medium: {
        width: '100%',
        display: 'none'
      },
      small: {
        display: 'none'
      }
    }
  }],
  responsiveStyles: {
    large: {
      display: 'flex',
      flexDirection: 'column',
      position: 'relative',
      flexShrink: '0',
      boxSizing: 'border-box',
      height: 'auto',
      flexGrow: '1'
    }
  }
}];
var CarouselBuilderComponent = {
  name: '_Carousel_',
  canHaveChildren: true,
  defaultStyles: {
    marginTop: '0px',
    height: '100%'
  },
  inputs: [{
    name: 'dotsVariation',
    helperText: 'Change dots style and position',
    type: 'string',
    "enum": ['default', 'center'],
    defaultValue: 'default'
  }, {
    name: 'dotsPosition',
    helperText: 'Position of the dots in respect to the carousel',
    type: 'string',
    defaultValue: 'outside',
    "enum": ['inside', 'outside'],
    showIf: function showIf(options) {
      return options.get('dotsVariation') === 'center';
    }
  }, {
    name: 'themeVersion',
    helperText: 'Change dots style color to theme version',
    type: 'string',
    defaultValue: 'light',
    "enum": ['light', 'dark']
  }, {
    name: 'dotsVerticalPosition',
    helperText: 'Adjust carousel dots vertical position',
    type: 'number',
    defaultValue: 25
  }, {
    name: 'infiniteScroll',
    helperText: 'Always rotate to the next slide',
    type: 'boolean',
    defaultValue: false
  }, {
    name: 'showdots',
    friendlyName: 'Enable dots nav',
    helperText: 'Show pagination dots',
    type: 'boolean',
    defaultValue: true
  }, {
    name: 'showarrows',
    friendlyName: 'Show Arrows',
    helperText: 'Show arrows',
    type: 'boolean',
    defaultValue: true
  }, {
    name: 'autoscroll',
    helperText: 'Automatically rotate to the next slide every few seconds',
    type: 'boolean',
    defaultValue: false
  }, {
    name: 'autoScrollSpeed',
    helperText: 'Speed in ms',
    type: 'number',
    defaultValue: 10000,
    showIf: function showIf(options) {
      return options.get('autoscroll') === true;
    }
  }, {
    name: 'slidesToShow',
    friendlyName: 'Slides to show on desktop',
    helperText: 'Only applies on desktop',
    type: 'number',
    max: 3,
    defaultValue: null
  }, {
    name: 'slidesToShowOnTablet',
    helperText: 'Only applies on tablet',
    type: 'number',
    max: 3,
    defaultValue: null
  }, {
    name: 'gapBetweenSlides',
    helperText: 'Gap between slides in px.',
    type: 'number',
    defaultValue: 16,
    showIf: function showIf(options) {
      return options.get('slidesToShow') > 1;
    }
  }, {
    name: 'slides',
    type: 'list',
    copyOnAdd: true,
    broadcast: true,
    subFields: [{
      name: 'content',
      type: 'uiBlocks'
    }, {
      name: 'membershipDisclaimerText',
      type: 'string'
    }, {
      name: 'hideFromBorderfree',
      type: 'boolean',
      defaultValue: false
    }, {
      name: 'lightTheme',
      type: 'boolean',
      defaultValue: false
    }, {
      name: 'slideUrl',
      type: 'string',
      defaultValue: '',
      helperText: 'Allow to be navigated to defined URL (if is empty, it will not be clickable)'
    }, {
      name: 'openNewTab',
      friendlyName: 'Open in new tab',
      type: 'boolean',
      defaultValue: false,
      helperText: 'If slideUrl is not empty, it will open it in a new tab'
    }, {
      name: 'trackingOptions',
      type: 'object',
      subFields: [{
        name: 'triggerClickEvent',
        type: 'boolean',
        helperText: 'If enabled, triggers event when the slide is clicked',
        defaultValue: true
      }, {
        name: 'triggerViewEvent',
        helperText: 'If enabled, triggers the view event when the slide is in the viewport',
        type: 'boolean',
        defaultValue: true
      }, {
        name: 'triggerViewEventOnce',
        helperText: 'If enabled, triggers the view event only once in the same session.',
        type: 'boolean',
        defaultValue: true
      }, {
        name: 'name',
        type: 'string',
        required: true
      }, {
        name: 'description',
        helperText: 'Corresponds to the "creative" field.',
        type: 'string',
        required: true
      }, {
        name: 'promotionId',
        helperText: 'Corresponds to the "image_id" field.',
        type: 'string',
        required: true
      }, {
        name: 'ctaText',
        helperText: 'when Promotion View/Clicked is triggered',
        type: 'string',
        required: true
      }, {
        name: 'targetUrl',
        helperText: 'when Promotion View/Clicked is triggered',
        type: 'string',
        required: true
      }]
    }],
    defaultValue: [{
      content: [defaultBlocks[0]],
      trackingOptions: {
        name: 'Carousel Slide',
        description: '',
        promotionId: '',
        ctaText: '',
        targetUrl: '',
        triggerViewEvent: true,
        triggerClickEvent: true,
        triggerViewEventOnce: true
      }
    }]
  }]
};
export default CarouselBuilderComponent;